import React from 'react';
import { Payload, ShopperExperienceDto, SingleGameScreenConfiguration } from '@luckycart/xpn-types';

import { BlockInfoType } from '../../common-types/BlockInfo.type';

import { WelcomeGameScreen } from './WelcomeGameScreen';

interface Props {
  config: SingleGameScreenConfiguration;
  ctaOnClick?: React.MouseEventHandler<HTMLDivElement>;
  addEditableBlock?: (block: BlockInfoType) => void;
  isEdition?: boolean;
  onBlockEdit?: React.MouseEventHandler<HTMLDivElement>;
  thumbnailUrls: { campId: string, url: string }[];
  currentShopperExperience?: ShopperExperienceDto<Payload> | null;
}

export const SingleGameScreen: React.FunctionComponent<Props> = (props: Props) => {
  return (
    <WelcomeGameScreen {...props} welcomeGameScreenType="singleGame" />
  );
};
